import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
export const handleDeleteAlert = createAsyncThunk("Alerts/handleDeleteAlert", async (data, thunkAPI) => {
    let alertId=data.id;
    delete data.id
  try {
    const resp = await axios.delete(`${process.env.REACT_APP_BASE_URL}api/events-alerts-v2/alert/${alertId}`, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return {...data,id:alertId};
  } catch (error) {
    if (error.response) {
      return thunkAPI.rejectWithValue(error.response.data.errorMessage || error.response.data.message);
    } else {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
});
